import { useState } from 'react';
import React from 'react';

const useAddPrescription = (selectedPatientData, dialog, tableRef) => {
  const [isAddPrescriptionDialogOpen, setisAddPrescriptionDialogOpen] = useState(false);

  const toggleAddPrescription = () => {
    setisAddPrescriptionDialogOpen(!isAddPrescriptionDialogOpen);
  };

  const onCloseModal = (needsReload?: boolean) => {
    toggleAddPrescription();

    if(needsReload && typeof needsReload === 'boolean') {
      tableRef.current && tableRef.current.onQueryChange()
    }
  }

  const renderModal = () => {
    if (!isAddPrescriptionDialogOpen) {
      return null;
    }

    const DialogComponent = dialog;
    return (
      <DialogComponent
        onClose={onCloseModal}
        isOpen={true}
        patientData={selectedPatientData}
      />
    );
  }
  return {
    isAddPrescriptionDialogOpen,
    toggleAddPrescription,
    addPrescriptionModal: renderModal()
  };
}

export default useAddPrescription;
